const BatchJobStatusColorTag = {
  Completed: '#7ECF42',
  Finished: '#7ECF42',
  Cancelled: '#E74C3C',
  NotFinished: '#F1C40F',
};
const BatchJobStatus = {
  Completed: 'Completed',
  Finished: 'Finished',
  Cancelled: 'Cancelled',
  NotFinished: 'Processing',
};
const BaselineStatusColorTag = {
  Completed: '#7ECF42',
  InCompleted: '#E74C3C',
};
const BaselineStatus = {
  Completed: 'Completed',
  InCompleted: 'InCompleted',
  Cancelled: 'Cancelled',
  InQueue: 'In Queue',
};
export { BatchJobStatusColorTag, BatchJobStatus, BaselineStatusColorTag, BaselineStatus };
